import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { motion as m, useMotionValue, useTransform, useSpring } from "framer-motion"
import store from "../store/store"
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded'
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded'

export default function Cards() {
  const recipes = store((state) => state.recipes)
  const setFavorite = store((state) => state.setFavorite)
  const isUserLogged = store((state) => state.isUserLogged)

  // create a new list
  let recipesToDisplay = recipes

  const handleFavorite = (id) => {
    setFavorite(id)
  }

  const navigate = useNavigate()


  const handleNavigate = (id) => {
    navigate(`/recipe/${id}`)
  }

  const animDuration = 0.3
  
  const spring = {
    type: "spring",
    damping: 20,
    stiffness: 600,
  };

  const containerVar = {
    initial: {
      x:'-100%',
      transition: {
        duration: animDuration,
      },
    },
    animate: {
      x: '0%',
      transition: {
        duration: animDuration,
      },
    },
    exit: {
        x: '-100%',
        transition: {
            duration: animDuration,
          },
    },
  }

  const cardVar = {
    initial: {
      opacity: 0,
    },
    animate: {
      opacity: 1,
      transition: {
        delay: .2,
      }
    },
  };

  const imgVar = {
    initial: {
      opacity: 0,
      translateY: 200,
    },
    animate: {
      opacity: 1,
      translateY: 0,
    },
  };

  const infosH3Var = {
    initial: {
      translateY: 40,
      opacity: 0,
    },
    animate: {
      opacity: 1,
      translateY: 0,
    },
  };

  const infosTextVar = {
    initial: {
      translateY: 40,
      opacity: 0,
    },
    animate: {
      translateY: 0,
      opacity: 1,
    },
  }


  return (
    <div id="cards_container">
      {recipesToDisplay.map((recipe) => (
        <div key={recipe.title + '_' + recipe.id} style={{ position: 'relative' }}>
          {isUserLogged?  
            recipe.favorite?
            <FavoriteRoundedIcon id='heart_icon' onClick={() => handleFavorite(recipe.id)}/> 
          : 
            <FavoriteBorderRoundedIcon id='heart_icon' onClick={() => handleFavorite(recipe.id)}/>
          :
            null
          }
          <div key={recipe.id} id="card_container" onClick={() => handleNavigate(recipe.id)}>
            <div id='card_img_container'>
              <img src={recipe.image} alt={recipe.title} />
              <div id='card_overlay'></div>
            </div>
            <div id="card_infos">
              <h3>{recipe.title}</h3>
              <p>{recipe.description}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}